"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightBoxStyles = void 0;
var tslib_1 = require("tslib");
var emotion_1 = require("emotion");
var appStylesBase_1 = require("./appStylesBase");
// import { BORDER_RADIUS } from 'constants/styleConstants'
var lightBoxStyles = function () { return (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: ", ";\n  background-color: ", ";\n"], ["\n  padding: ", ";\n  background-color: ", ";\n"])), (0, appStylesBase_1.appStylesBase)().spacing.medium, (0, appStylesBase_1.appStylesBase)().backgroundColor.neutral.lightest); };
exports.lightBoxStyles = lightBoxStyles;
var templateObject_1;
